<template>
  <div class="bg-white p-6 rounded-lg">
    <div class="flex flex-col space-y-1">
      <p class="item-title">Sucursal {{ branch.Nombre }}</p>
      <p class="item-subtitle">ID sucursal: {{ branch.IdSucursal }}</p>
    </div>

    <div class="flex flex-col space-y-6 mt-4">
      <div class="flex justify-around w-full space-x-2">
        <div class="flex flex-col">
          <label class="text-xs pl-2" for="city">Ciudad</label>
          <input
            readonly
            class="input-branch"
            name="city"
            type="text"
            :value="branch.Ciudad"
          />
        </div>

        <div class="flex flex-col">
          <label class="text-xs pl-2" for="province">Provincia</label>
          <input
            readonly
            class="input-branch"
            name="province"
            type="text"
            :value="branch.Provincia"
          />
        </div>

        <div class="flex flex-col">
          <label class="text-xs pl-2" for="address">Domicilio</label>
          <input
            readonly
            class="input-branch"
            name="address"
            type="text"
            :value="branch.Domicilio"
          />
        </div>
      </div>
      <div class="flex justify-around w-full space-x-2">
        <div class="flex flex-col">
          <label class="text-xs pl-2" for="postalCode">Postal Code</label>
          <input
            readonly
            class="input-branch"
            name="postalCode"
            type="text"
            :value="branch.CP"
          />
        </div>

        <div class="flex flex-col">
          <label class="text-xs pl-2" for="phone">Teléfono</label>
          <input
            readonly
            class="input-branch"
            name="phone"
            type="text"
            :value="branch.Telefono"
          />
        </div>

        <div class="flex flex-col">
          <label class="text-xs pl-2" for="email">Email</label>
          <input
            readonly
            class="input-branch"
            name="email"
            type="text"
            :value="branch.Email"
          />
        </div>
      </div>
      <div class="flex justify-around w-full space-x-2">
        <div class="flex flex-col">
          <label class="text-xs pl-2" for="schedule">Horario</label>
          <input
            readonly
            class="input-branch"
            name="schedule"
            type="text"
            :value="branch.Horario"
          />
        </div>
        <div class="flex flex-col">
          <label class="text-xs pl-2" for="longitude">Longitud</label>
          <input
            readonly
            class="input-branch"
            name="longitude"
            type="text"
            :value="branch.Longitud"
          />
        </div>
        <div class="flex flex-col">
          <label class="text-xs pl-2" for="latitude">Latitud</label>
          <input
            readonly
            class="input-branch"
            name="latitude"
            type="text"
            :value="branch.Latitud"
          />
        </div>
      </div>
      <div>
        <label class="text-xs pl-4" for="">Almacenamiento</label>
        <div class="toggle-button-cover">
          <div class="button-cover">
            <div class="button b2" id="button-16">
              <input
                readonly
                type="checkbox"
                class="checkbox"
                :checked="branch.TieneAlmacenamiento !== 'NO'"
              />
              <div class="knobs"></div>
              <div class="layer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalStorage } from "../../utils/utils";
export default {
  name: "BranchesSettings",
  data() {
    return {
      branch: [],
      branches: [],
      branchId: null,
    };
  },
  mounted() {
    this.getBranchesLocalStorage();
    this.getBranchId();
    this.findBranch();
  },
  methods: {
    findBranch() {
      const data = this.branches.filter(
        (item) => item.IdSucursal.toString() === this.branchId
      );
      this.branch = data[0] || [];
    },
    getBranchesLocalStorage() {
      this.branches = getLocalStorage("branches");
    },
    getBranchId() {
      this.branchId = this.$route.query.branchId;
    },
  },
};
</script>
